// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'https://shobizdigital.in/'
  // apiUrl: 'https://api.shobizdigital.in:9396/',
  // apiUrl: 'https://web.shobizdigital.in:5000/',
  // apiUrl: 'https://clarivate.shobizdigital.in:9396/',
  // apiUrl: 'https://showbiz.softprodigyphp.in/',
  apiUrl: 'https://api.shobizdigital.in/',
  // apiUrl: 'http://showbiz.softprodigyphp.in/',
  // apiUrl: 'http://showbiz.softprodigyphp.in/',
  // apiUrl: 'https://www.shobizdigital.in:9396/',
  eventName: ''
  // apiUrl: 'http://30a74e55d271.ngrok.io/',
};

/* 
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
